import { Stack } from '@superdispatch/ui';
import { useMemo } from 'react';
import {
  getShipperRatingTagDisplayName,
  ShipperRatingDTO,
} from 'shared/modules/ratings/data/ShipperRatingDTO';
import { Review } from 'shared/modules/ratings/Review';
import { ReviewResponse } from 'shared/modules/ratings/ReviewResponse';
import { ShipperAvatar } from 'shared/modules/shipper/ShipperAvatar';
import { ShipperProfileDTO } from 'shared/modules/shipper/ShipperProfileDTO';

interface ShipperRatingProps {
  rating: ShipperRatingDTO;
  carrierName?: string;
  shipperProfile: ShipperProfileDTO;
  onClickEdit?: () => void;
  onClickDelete?: () => void;
}

export function ShipperRating({
  rating,
  carrierName,
  shipperProfile,
  onClickEdit,
  onClickDelete,
}: ShipperRatingProps) {
  const isPositiveRating = rating.rating === 'POSITIVE';
  const tags = useMemo(
    () => rating.tags?.map(getShipperRatingTagDisplayName),
    [rating.tags],
  );

  return (
    <Review
      author={carrierName || 'Carrier'}
      reviewDate={rating.created_at}
      variant={isPositiveRating ? 'positive' : 'negative'}
      comment={rating.comment}
      tags={tags}
      onClickEdit={onClickEdit}
      onClickDelete={onClickDelete}
      status={rating.status === 'PUBLISHED' ? 'published' : 'pending'}
      response={
        !isPositiveRating &&
        rating.response && (
          <ReviewResponse
            author={`Response from ${shipperProfile.name}`}
            avatar={
              <ShipperAvatar
                name={shipperProfile.name}
                logo={shipperProfile.logo_url}
              />
            }
            responseDate={rating.response_date}
            response={rating.response}
          />
        )
      }
    />
  );
}

export function ShipperRatingsList({
  ratings,
  shipperProfile,
}: {
  ratings: ShipperRatingDTO[];
  shipperProfile: ShipperProfileDTO;
}) {
  return (
    <Stack space="large">
      {ratings.map((rating) => (
        <ShipperRating
          key={rating.guid}
          rating={rating}
          shipperProfile={shipperProfile}
        />
      ))}
    </Stack>
  );
}
